import {User} from './user';
import {OrganizationModel} from './organization.model';

export class OrganizationAdminsDataModel {
  admins: User[];
  organization: OrganizationModel;
}

